module.exports = "<div class=\"popup closed-loop-popup\">\n  <div class=\"award-image-container\">\n    <div style=\"position: relative\">\n      <div class=\"award-type-image\"></div>\n      <label class=\"award-points-text\">3</label>\n    </div>\n  </div>\n  <div class=\"popup-title\"></div>\n  <div class=\"popup-message\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/views/partials/popup/closed-loop.html
// module id = 814
// module chunks = 2